var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTwitter16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.76663C15.4113 2.02796 14.7787 2.20396 14.1147 2.28329C14.7927 1.87729 15.3133 1.23396 15.558 0.467295C14.924 0.843295 14.2213 1.11663 13.4733 1.26396C12.8753 0.625962 12.0213 0.227295 11.0773 0.227295C8.958 0.227295 7.40067 2.20463 7.87933 4.2573C5.152 4.12063 2.73333 2.81396 1.114 0.827962C0.254 2.3033 0.668 4.23329 2.12933 5.21063C1.592 5.19329 1.08533 5.04596 0.643333 4.79996C0.607333 6.32063 1.69733 7.74329 3.276 8.05996C2.814 8.18529 2.308 8.21463 1.79333 8.11596C2.21067 9.41996 3.42267 10.3686 4.86 10.3953C3.48 11.4773 1.74133 11.9606 0 11.7553C1.45267 12.6866 3.17867 13.23 5.032 13.23C11.1267 13.23 14.57 8.08263 14.362 3.46596C15.0033 3.00263 15.56 2.42463 16 1.76663V1.76663Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;